import React, { useCallback, useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { HeaderSpacer } from '../components/Header';
import ListHeroPage from '../components/ListHeroPage';
import { OutlinedButton, PageBackground } from '../components/common/hero/styles';
import { TEXT_DARK, TEXT_SECONDARY } from '../components/common/tokens';
import { getNamespacePath, selectContext, selectContextStatus } from '../redux/features/context/contextSlice';
import { fetchList } from '../redux/features/lists/listsSlice';
import StyledBackdrop from '../components/StyledBackdrop';
import Login from '../components/Login';
import { hasFlag, withoutFlag } from '../common/UrlFlags';

export default function ListReadView(props) {
  const { namespace: propNamespace } = props;
  const { listId } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const { userInfo } = useSelector((state) => state.users);
  const status = useSelector(selectContextStatus);
  const currContext = useSelector(selectContext);

  const namespace = propNamespace || (userInfo ? 'private' : 'public');

  const loadList = useCallback(
    () => dispatch(fetchList({ namespace, listId })),
    [dispatch, namespace, listId],
  );

  const [startInEdit] = useState(() => hasFlag(searchParams, 'edit'));
  useEffect(() => {
    if (hasFlag(searchParams, 'edit')) {
      setSearchParams(withoutFlag(searchParams, 'edit'), { replace: true });
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    loadList();
  }, [loadList]);

  let listInfo;
  let forceSignIn = false;
  let notFound = false;

  if (currContext?.type === 'list' && currContext.listInfo?.id === listId) {
    listInfo = currContext.listInfo;
  } else if (status !== 'loading' && currContext?.type === 'list' && !currContext.listInfo) {
    forceSignIn = true;
  } else if (status === 'failed') {
    if (userInfo) {
      notFound = true;
    } else {
      forceSignIn = true;
    }
  }

  const showSpinner = !forceSignIn && !notFound && !listInfo;

  return (
    <>
      <HeaderSpacer />
      {forceSignIn && <Login />}
      {notFound && (
        <PageBackground>
          <div style={{ textAlign: 'center', paddingTop: 48 }}>
            <h2 style={{ color: TEXT_DARK, fontWeight: 700, margin: '0 0 8px' }}>
              List not found
            </h2>
            <p style={{ color: TEXT_SECONDARY, margin: '0 0 20px' }}>
              This list doesn&apos;t exist or is no longer available.
            </p>
            <OutlinedButton
              type="button"
              onClick={() => navigate(`/${getNamespacePath(namespace)}/lists`)}
            >
              Browse lists
            </OutlinedButton>
          </div>
        </PageBackground>
      )}
      {showSpinner && (
        <StyledBackdrop open>
          <CircularProgress color="inherit" />
        </StyledBackdrop>
      )}
      {!forceSignIn && !notFound && listInfo && (
        <ListHeroPage
          listInfo={listInfo}
          namespace={namespace}
          startInEdit={startInEdit}
          onRefetch={loadList}
        />
      )}
    </>
  );
}
